<!-- main banner  -->
<div class="collab-banner sticky-header-banner banner-sec black-text">
    <div class="container">
        <div class="sec-padding m-col-width mt-negative">
           
            <div class="z-index pb-2">
                <div class="row mx-0 m-col-width">
                    <div class="col-md-6 col-sm-12 px-0 m-mb">
                        <div class="whats-new-label dark-banner">
                            <div class="wave-container">
                                <div class="wave-dot wave-dot-1"></div> 
                                <div class="wave-dot wave-dot-3"></div> 
                            </div> 
                            <span class="primary-color paragraph-global-text sub-head-paragraph">
                                {{'one-to-one-chat.banner.preTitle' | translate}}
                            </span>
                        </div>
        
                        <h1 class="banner-heading mw-700">{{'one-to-one-chat.banner.title' | translate}} {{'one-to-one-chat.banner.title2' | translate}}</h1>
                        <p class="paragraph-global-text mw-500">{{'one-to-one-chat.banner.description' | translate}}</p>
                       <div class="d-flex align-items-center my-3">
                            <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                                <button class="save-btn">
                                    {{'one-to-one-chat.banner.cta1' | translate}}
                                </button>
                            </a>
                            <a [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                                <button class="save-btn cfa ml-4">
                                    {{'one-to-one-chat.banner.cta2' | translate}}
                                    <i class="pi pi-arrow-right title-color ml-2"></i>
                                </button>
                            </a>
                       </div>                      
                    </div>
                    <div class="col-md-6 col-sm-12 pr-0 d-flex align-items-center">
                        <figure>
                            <img class="w-100 pl-4" width="300" src="../../../assets/icons/find-answers/find-answer-banner.svg" alt="find answers">
                        </figure>
                    </div>
                </div>                
            </div>           
        </div>
    </div>
</div>


  <!-- key features sec  -->
  <div class="sec-padding">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'one-to-one-chat.keyFeatures.title' | translate}} <br> {{'one-to-one-chat.keyFeatures.title2' | translate}}</h2>
        </div>

        <!-- cards  -->
        <div class="row mx-0 m-col-width card-v-gap">
            <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <div class="card banner-cards justify-content-between">
                    <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-message-circle icon-primary-color"><path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"/></svg>
                         </div>
                         <h4 class="heading-three">{{'one-to-one-chat.keyFeatures.feature1.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'one-to-one-chat.keyFeatures.feature1.description' | translate}}</p>
                    </div>
                </div>
             </div>
             <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                      <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-link icon-primary-color"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                          </div>
                          <h4 class="heading-three">{{'one-to-one-chat.keyFeatures.feature2.title' | translate}}</h4>
                          <p class="paragraph-global-text sub-head-paragraph mw-300">{{'one-to-one-chat.keyFeatures.feature2.description' | translate}}</p>
                      </div>
                 </div>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                 <div class="card banner-cards justify-content-between">
                     <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-lock icon-primary-color"><rect width="18" height="11" x="3" y="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
                         </div>
                         <h4 class="heading-three">{{'one-to-one-chat.keyFeatures.feature3.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-300">{{'one-to-one-chat.keyFeatures.feature3.description' | translate}}</p>
                     </div>
                 </div>
             </div> 
             <div class="col-lg-3 col-md-6 col-sm-6 col-xs-12">
                <div class="card banner-cards justify-content-between">
                    <div>
                        <div class="rounded-img-bg w-fit mb-4 p-3 h-fit mr-auto">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-globe icon-primary-color"><circle cx="12" cy="12" r="10"/><path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path d="M2 12h20"/></svg>
                        </div>
                        <h4 class="heading-three">{{'one-to-one-chat.keyFeatures.feature4.title' | translate}}</h4>
                        <p class="paragraph-global-text sub-head-paragraph mw-300">{{'one-to-one-chat.keyFeatures.feature4.description' | translate}}</p>
                    </div>
                </div>
            </div>             
        </div>
    </div>
</div>


  <!-- simpleChatInterface  sec  -->
  <div class="sec-padding section_bg">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'one-to-one-chat.simpleChatInterface.title' | translate}} {{'one-to-one-chat.simpleChatInterface.title2' | translate}}</h2>
        </div>

        <div class="text-center mx-auto mw-800">
            <figure>
                <img class="w-100" src="../../../assets/icons/collaboration-features/one-to-one-chat-window.svg" alt="">
            </figure>
        </div>
    </div>
</div>



<!-- amypro_one_to_one_messaging  section-->
<div class="sec-padding amypro_one_to_one_messaging-sec">
    <div class="container position-relative">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{"one-to-one-chat.amypro_one_to_one_messaging.title" | translate}} {{"one-to-one-chat.amypro_one_to_one_messaging.title2" | translate}}</h2>
        </div>
        <div class="row mx-0 m-col-width">
            <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <h6 class="heading-three">{{'one-to-one-chat.amypro_one_to_one_messaging.feature1.title' | translate}}</h6>
                    <p class="paragraph-global-text mb-0">{{'one-to-one-chat.amypro_one_to_one_messaging.feature1.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <h6 class="heading-three">{{'one-to-one-chat.amypro_one_to_one_messaging.feature2.title' | translate}}</h6>
                    <p class="paragraph-global-text mb-0">{{'one-to-one-chat.amypro_one_to_one_messaging.feature2.description' | translate}}</p>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <h6 class="heading-three">{{'one-to-one-chat.amypro_one_to_one_messaging.feature3.title' | translate}}</h6>
                    <p class="paragraph-global-text mb-0">{{'one-to-one-chat.amypro_one_to_one_messaging.feature3.description' | translate}}</p>
                </div>
             </div>
        </div>
    </div>
</div>

<div class="sec-padding section_bg">    
    <div class="container z-index">

        <!-- cards  -->
        <div class="white-bg-sec">
            <div class="row mx-0 m-col-width card-v-gap m-flex-column-reverce">
                <div class="col-md-6 col-sm-12 pl-0">
                   <div class="d-flex justify-content-center flex-column h-100">
                        <h2 class="heading-one">{{'one-to-one-chat.integration_with_external_tools.title' | translate}} {{'one-to-one-chat.integration_with_external_tools.title2' | translate}}</h2>
                        <p class="paragraph-global-text mb-4 mw-450">{{'one-to-one-chat.integration_with_external_tools.subtitle' | translate}}</p>
                        <p class="paragraph-global-text mb-3 d-flex align-items-center"> <span> <i class="pi pi-check-circle"></i> </span> {{'one-to-one-chat.integration_with_external_tools.tools1' | translate}}</p>
                        <p class="paragraph-global-text mb-3 d-flex align-items-center"> <span><i class="pi pi-check-circle"></i></span> {{'one-to-one-chat.integration_with_external_tools.tools2' | translate}}</p>
                        <p class="paragraph-global-text mb-3 d-flex align-items-center"> <span><i class="pi pi-check-circle"></i></span> {{'one-to-one-chat.integration_with_external_tools.tools3' | translate}}</p>
                        <p class="paragraph-global-text mb-3 d-flex align-items-center"> <span><i class="pi pi-check-circle"></i></span> {{'one-to-one-chat.integration_with_external_tools.tools4' | translate}}</p>
                        <p class="paragraph-global-text mw-450">{{'one-to-one-chat.integration_with_external_tools.description' | translate}}</p>
                   </div>
                </div>
                <div class="col-md-6 col-sm-12 pr-0 m-mb m-auto">
                    <figure>
                        <img class="w-100" src="../../assets/icons/Homepage/features/features.svg" alt="">
                    </figure>
                </div>
            </div>
        </div>
    </div>
</div>



<div class="sec-padding why_find_Ans_sec">    
    <div class="container z-index">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto">{{'one-to-one-chat.whyDifferent.title' | translate}} {{'one-to-one-chat.whyDifferent.title2' | translate}} {{'one-to-one-chat.whyDifferent.title3' | translate}}</h2>
        </div>
        <div class="row mx-0 m-col-width card-v-gap">   
             <div class="col-md-6 col-sm-12">
                <div class="card banner-bg-card card-hover-effect">
                    <div class="card-content">
                        <h4 class="heading-three mw-400">{{'one-to-one-chat.whyDifferent.section1.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-400">{{'one-to-one-chat.whyDifferent.section1.description' | translate}}</p>
                    </div>
                    <img class="card-image" src=".././../../assets/icons/find-answers/why-find-answ-4.svg" alt="card-image">
                </div>
             </div>
             <div class="col-md-6 col-sm-12">
                <div class="card banner-bg-card card-hover-effect">
                    <div class="card-content">
                        <h4 class="heading-three mw-400">{{'one-to-one-chat.whyDifferent.section2.title' | translate}}</h4>
                         <p class="paragraph-global-text sub-head-paragraph mw-400">{{'one-to-one-chat.whyDifferent.section2.description' | translate}}</p>
                    </div>
                    <img class="card-image" src=".././../../assets/icons/find-answers/why-find-answ-4.svg" alt="card-image">
                </div>                
             </div>
        </div>
    </div>
</div>

<!-- testimonials  section-->
<div class="sec-padding testimonials-sec section_bg">
    <div class="container position-relative">
        <div class="sec-title pb-3 mb-5 text-center">
            <h2 class="heading-one mx-auto mw-800">{{"one-to-one-chat.testimonials.title" | translate}} {{"one-to-one-chat.testimonials.title2" | translate}}</h2>
        </div>
        <div class="row mx-0 m-col-width">
            <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                   <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating1"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating1 | number: '1.1-1' }}</span>
                        </div>
                        <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'one-to-one-chat.testimonials.section1.review' | translate}}”</p>
                   </div>
                     <div class="d-flex align-items-center mt-3">
                        <div>
                            <h6 class="card-title mb-1">{{'one-to-one-chat.testimonials.section1.title' | translate}}</h6>
                            <span class="sub-heading-color">{{'one-to-one-chat.testimonials.section1.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating2"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating2 | number: '1.1-1' }}</span>
                        </div>
                         <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'one-to-one-chat.testimonials.section2.review' | translate}}”</p>
                    </div>
                     <div class="d-flex align-items-center mt-3">
                        <div class="">
                            <h6 class="card-title mb-1">{{'one-to-one-chat.testimonials.section2.title' | translate}}</h6>
                            <span class="sub-heading-color">{{'one-to-one-chat.testimonials.section2.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
             <div class="col-md-4 col-sm-6 col-xs-12 pt-4">
                <div class="card why-amy-cards reviews">
                    <div>
                        <div class="d-flex align-items-center mb-4 w-100">
                            <app-start-rating-readonly [rating]="rating3"></app-start-rating-readonly>                          
                            <span class="ml-2 sub-heading-color">{{rating3 | number: '1.1-1' }}</span>
                        </div>
                         <p class="paragraph-global-text sub-head-paragraph mw-300 mb-0">“{{'one-to-one-chat.testimonials.section3.review' | translate}}”</p>
                    </div>
                     <div class="d-flex align-items-center mt-3">
                        <div class="">
                            <h6 class="card-title mb-1">{{'one-to-one-chat.testimonials.section3.title' | translate}}</h6>
                            <span class="sub-heading-color">{{'one-to-one-chat.testimonials.section3.role' | translate}}</span>
                        </div>
                     </div>
                </div>
             </div>
        </div>
    </div>
</div>


  <!-- faqs  -->
  <div class="sec-padding mcqs-sec">
    <div class="container">
      <div class="text-center mb-5 pb-4">
        <div class="content-sec">
          <h1 class="heading-one">
            {{'one-to-one-chat.faq.title' | translate}}
            {{'one-to-one-chat.faq.title2' | translate}}
          </h1>
        </div>
      </div>
  
      <div class="accordion mw-800 mx-auto">
        <app-simple-expansion [panels]="projectProgressOptions"></app-simple-expansion>
      </div>
    </div>
  </div> 

  <div class="sec-padding cfa-sec position-relative">    
      <div class="cfa-grid"></div>
    <div class="container z-index">
        <div class="sec-title text-center">
            <h2 class="heading-one text-white mx-auto">{{'one-to-one-chat.cfa.title' | translate}} </h2>
            <p class="paragraph-global-text sub-head-paragraph mw-750 text-white">{{'one-to-one-chat.cfa.description' | translate}}</p>
  
            <div class="button-container mt-4">
                <a class="save-btn cfa btn" [href]="signUrl+'get-started/u/setup-profile?returnUrl=amy'" target="_blank">
                    {{'one-to-one-chat.cfa.buttonTxt' | translate}}
                </a>
            </div>
        </div>
    </div>
  </div>